var React = require('react');

function TeamsLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21 13H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V14a1 1 0 00-1-1zM3 11a3 3 0 00-3 3v18a3 3 0 003 3h18a3 3 0 003-3V14a3 3 0 00-3-3H3z","key":0}),React.createElement("path",{"d":"M6 17h12v2H6v-2z","key":1}),React.createElement("path",{"d":"M13 17v12h-2V17h2z","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25 4a5 5 0 00-4.332 7.5l-1.73 1a7 7 0 113.73 3.1l.665-1.884A5 5 0 1025 4zm15.5 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 2a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM34 21H23v-2h13v15c0 6.075-4.925 11-11 11s-11-4.925-11-11h2a9 9 0 1018 0V21z","key":3}),React.createElement("path",{"d":"M48 30.5a8.5 8.5 0 01-13.608 6.795L35 35.19a6.5 6.5 0 0011-4.69V21H35v-2h13v11.5z","key":4})]);
}

TeamsLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = TeamsLight;

TeamsLight.default = TeamsLight;
